<template>
    <page title="competitionTitle" :help="help">
        <template #pageContainer>
            <v-row>
                <!-- <v-col
                    cols="12"
                    md="12">
                    <v-card outlined>
                        <v-row
                            align="center"
                            justify="center">
                            <v-col
                                cols="12"
                                md="4"
                                sm="4">
                                <v-card-text>
                                    <v-icon>edit</v-icon>
                                    {{ $t(`text.edit`) }}
                                </v-card-text>
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                                sm="4">
                                <v-card-text>
                                    <v-icon>delete</v-icon>
                                    {{ $t(`text.delete`) }}
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col> -->
                <v-col
                    cols="12"
                    md="12" class="py-1">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="Entities"
                            item-key="id"
                            class="elevation-1"
                            :items-per-page="400"
                            :loading="loading"
                            :loading-text="$t('text.competitionLoading')"
                            :server-items-length="Entities.length"
                            hide-default-footer
							:height="WindowSize.y - 380"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
                                        <v-col cols="12" sm="3" lg="2">
                                            <v-btn-toggle dense color="primary">
                                                <v-btn
                                                    class="new-competition"
                                                    color="primary"
                                                    @click="newCompetition">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.newCompetition`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        add
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
										<v-col cols="12" sm="6" lg="6">
                                            <v-text-field outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.freetextSearch"
                                                :label="$t('text.name') +'/'+ $t('text.competitionLocation')"
                                                @keyup.enter.native="search">
                                            </v-text-field>
                                        </v-col>

                                        <v-col cols="12" sm="2" lg="2">
											<v-menu v-model="dateMenu" :close-on-content-click="false" max-width="290">
												<template #activator="{ on }">
													<v-text-field outlined dense
														hide-details="auto"
														class="mt-0 pt-0"
														:value="FormattedDate"
														clearable
														:label="$t('text.date')"
														readonly
														v-on="on"
														@click:clear="tempQP.dateFrom = null"
														required>
													</v-text-field>
												</template>
												<v-date-picker locale="DE-de" v-model="tempQP.dateFrom" @change="dateMenu = false">
												</v-date-picker>
											</v-menu>
                                        </v-col>

                                        <v-col cols="12" sm="2" lg="2"
											align="right">
                                            <v-btn-toggle dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
                                                    color="secondary"
                                                    @click="search">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.searchButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        search
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template #[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="edit(item.id)"
                                            :disabled="item.importSource != 'portal'">
                                            <v-icon>
                                                edit
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.edit`) }}</span>
                                </v-tooltip>
								<!-- <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="deleteCompetition(item.id)">
                                            <v-icon>
                                                delete
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.delete`) }}</span>
                                </v-tooltip> -->
                            </template>
                            <template #[`item.dateFrom`]="{ item }">
                                <div>
									<div><template v-if="item.dateFrom != item.dateTo">{{ $t(`text.from`) }}: </template>{{ item.dateFrom | moment('DD.MM.YYYY') }}</div>
									<div v-if="item.dateFrom != item.dateTo">{{ $t(`text.till`) }}: {{ item.dateTo | moment('DD.MM.YYYY') }}</div>
								</div>
                            </template>
                            <template #[`item.town`]="{ item }">
                                <div>
									<div>{{ item.town }} ({{ item.nation }})</div>
									<div style="color:#444; font-size:9px;">{{ item.location}}</div>
                                </div>
                            </template>
                            <!-- <template #[`item.dateTo`]="{ item }">
                                {{ item.dateTo | moment('DD.MM.YYYY') }}
                            </template> -->
                        </v-data-table>

                        <pagination
                            :currentPage="Pagination.currentPage"
                            :totalPages="Pagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';

import competitionActions from '../store/actions/competition';
import namespace from '../store/namespace';

import modelState from '../mixins/modelState';

class TempCompetitionQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.dateFrom = qp.dateFrom;
		}
	}
}

class CompetitionQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.dateFrom = qp.dateFrom;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;
		} else {
			this.pageNumber = 1;
			this.pageSize = 10;
			this.dateFrom = null;
			this.freetextSearch = '';
		}
	}

	updateTempData(tempQP) {
		this.dateFrom = tempQP.dateFrom;
		this.freetextSearch = tempQP.freetextSearch;
	}
}

export default {
	name: 'Competition',
	mixins: [modelState],
	components: {
		Page,
		Pagination,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: 104,
				},
				{
					text: this.$i18n.t('text.headerName'), align: 'left', value: 'name', sortable: false,
				},
				{
					text: this.$i18n.t('text.date'), align: 'center', value: 'dateFrom', sortable: false, width: 150,
				},
				// {
				// 	text: this.$i18n.t('text.headerDateTo'), align: 'left', value: 'dateTo', sortable: false, width: 100,
				// },
				{
					text: this.$i18n.t('text.competitionLocation'), align: 'left', value: 'town', sortable: false, width: 150,
				},
				// {
				// 	text: this.$i18n.t('text.headerLocation'), align: 'left', value: 'location', sortable: false, width: 150,
				// },
				// {
				// 	text: this.$i18n.t('text.headerNation'), align: 'left', value: 'nation', sortable: false, width: 70,
				// },
				{
					text: this.$i18n.t('text.headerArea'), align: 'left', value: 'area', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerDistrict'), align: 'left', value: 'district', sortable: false,
				},
				{
					text: this.$i18n.t('text.stateAssociation'), align: 'left', value: 'stateCode', sortable: false, width: 70,
				},
			],
			loading: true,
			queryParameters: new CompetitionQueryParameter(),
			tempQP: new TempCompetitionQueryParameter(),
			dateMenu: false,
			help: [
			// 	{
			// 	icon: 'delete',
			// 	text: this.$t('text.delete'),
			// },
				{
					icon: 'edit',
					text: this.$t('text.edit'),
				}],
		};
	},
	watch: {
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('competitionsApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	async mounted() {
		if (localStorage.getItem('competitionsApp')) {
			this.queryParameters = new CompetitionQueryParameter(JSON.parse(localStorage.getItem('competitionsApp')));
			this.tempQP = new TempCompetitionQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('competitionsApp', JSON.stringify(this.queryParameters));
		}
		await this.loadData();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITION, ['Links', 'Entities', 'Pagination']),
		...mapGetters(namespace.ORGANIZATION, ['Organization']),
		nonContentPage() {
			return this.Entities.length == 0;
		},
		FormattedDate() {
			return this.tempQP.dateFrom ? this.$moment(this.tempQP.dateFrom).format('DD.MM.YYYY') : null;
		},
	},
	methods: {
		...mapActions(namespace.COMPETITION, [
			competitionActions.GET_COMPETITION,
			// competitionActions.DELETE_COMPETITION
		]),
		async loadData() {
			this.loading = true;
			try {
				await this.GET_COMPETITION({queryParameters:this.queryParameters, currentOrgId:this.Organization});
			} finally {
				this.loading = false;
			}
		},
		async getPerformanceCompetitionsLinks() {
			try {
				await this.GET_PERFORMANCE_COMPETITION_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async edit(id) {
			this.$router.push({
				name: 'updatecompetition',
				params: {
					id,
				},
			});
		},
		async search() {
			this.queryParameters.updateTempData(this.tempQP);
			localStorage.setItem('competitionsApp', JSON.stringify(this.queryParameters));
			this.queryParameters.pageNumber = 1;
			await this.loadData();
		},
		// async deleteCompetition(id) {
		// 	// eslint-disable-next-line no-restricted-globals, no-alert
		// 	const r = confirm(this.$i18n.t('text.deleteRequest'));
		// 	if (r === true) {
		// 		try {
		// 			const link = this.Links.find(x => x.rel === 'delete_competition');
		// 			if (link) {
		// 				const href = link.href
		// 					.replace('{id}', id);
		// 				await this.DELETE_COMPETITION({ href });
		// 				this.loadData(this.queryParameters);
		// 			}
		// 		} catch (ex) {
		// 			console.log(ex);
		// 		}
		// 	}
		// },
		async pageSizeChanged(newPageSize) {
			const maxPage = Math.ceil(this.Pagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.Pagination.currentPage ? maxPage : this.Pagination.currentPage;
			this.queryParameters.pageSize = newPageSize;
			await this.loadData();
		},
		newCompetition() {
			this.$router.push({
				name: 'newcompetition',
			});
		},
		async update(item) {
			this.loading = true;
			try {
				await this.UPDATE_CHECKING(item);

				await this.loadData();
			} finally {
				this.loading = false;
			}
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;

			await this.loadData();
		},
	},
};
</script>

<style lang="scss" scoped>
.new-competition {
    span {
        font-size: .675rem !important;
    }
}

.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}
</style>
